export default __webpack_public_path__ + "static/banner-three-shape2-c0fce29a8e3a3127aa22fb77db18dcea.png";